import { useCallback, useEffect, useMemo, useState } from 'react';
import { Link as RouterLink, useLocation, useParams } from 'react-router-dom';
import {
  Card,
  Container,
  Stack,
  Link,
  Typography,
  TextField,
  Select,
  MenuItem,
  Tooltip,
  IconButton,
  Button,
  Grid,
  FormControl,
  InputLabel,
  styled
} from '@mui/material';
import { Box } from '@mui/system';
// other icons
import { Icon } from '@iconify/react';
import add from '@iconify/icons-ic/add';
import remove from '@iconify/icons-ic/sharp-minus';
// react icons
import { BsWindowDock, BsCardHeading, BsTelephone } from 'react-icons/bs';
import { AiOutlineClockCircle, AiOutlineIdcard } from 'react-icons/ai';
import { RiBankCardLine } from 'react-icons/ri';
import { FaRegAddressCard, FaRegUser } from 'react-icons/fa';
import { CgCalendarDates } from 'react-icons/cg';
import { HiOutlineMail } from 'react-icons/hi';
import { SiOpensourceinitiative } from 'react-icons/si';
import { GiSwapBag, GiModernCity } from 'react-icons/gi';
import { MdIncompleteCircle, MdOutlineDateRange } from 'react-icons/md';
import { BiCloudUpload, BiCloudDownload, BiBoltCircle } from 'react-icons/bi';
// material icons
import StayCurrentPortraitIcon from '@mui/icons-material/StayCurrentPortrait';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import UpdateIcon from '@mui/icons-material/Update';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { useDispatch } from 'react-redux';
import InterestsIcon from '@mui/icons-material/Interests';
import SourceIcon from '@mui/icons-material/Source';
import GroupIcon from '@mui/icons-material/Group';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { isValidValue } from '../../utils/CommonFunction';
import useRejectedSelector from '../../store/Slice/Rejected/RejectedSelector';
// components
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import { getRejectedView } from '../../store/Slice/Rejected/RejectedSlice';
import ViewCardComponent from '../../components/ViewCards';

function ViewRejected() {
  const [showProspectDetail, setShowProspectDetail] = useState(false);
  const [showCallCenterDetail, setShowCallCenterDetail] = useState(false);
  const [showLeadsDetail, setShowLeadsDetail] = useState(false);
  const { state } = useLocation();
  const { rowId } = state || {};
  const { RejectedViewData } = useRejectedSelector();

  // const result = state();

  // console.log('rejected view data', RejectedViewData);

  const [file, setFile] = useState();
  function handleChange(e) {
    setFile(URL.createObjectURL(e.target.files[0]));
  }
  const { LoginData } = useLoginSelector();
  const dispatch = useDispatch();

  const Input = styled('input')({
    display: 'none'
  });

  const getRejectedListApi = useCallback(async () => {
    const credentials = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      applicationId: rowId?.applicationId,
      stageId: 60
    };

    const result = await dispatch(getRejectedView(credentials));
    // console.log('view rejected list', result);
  }, [LoginData, rowId, dispatch]);

  useEffect(() => {
    getRejectedListApi();
  }, [getRejectedListApi]);

  const loanRequirementField = useMemo(() => {
    const model = RejectedViewData?.rejectedApplicationEntityLoanRequirementResponseModel || {};

    // console.log('model', model);

    return [
      {
        label: 'city',
        value: model?.city,
        icon: <FaRegUser className="viewLabelIcon" size={24} />
      },
      {
        label: 'employmentType',
        value: model?.employmentType,
        icon: <InterestsIcon className="viewLabelIcon" size={24} />
      },
      {
        label: 'leadEmail',
        value: model?.leadEmail,
        icon: <InterestsIcon className="viewLabelIcon" size={24} />
      },
      {
        label: 'leadName',
        value: model?.leadName,
        icon: <GiSwapBag className="viewLabelIcon" size={24} />
      },
      {
        label: 'leadPhoneNumber',
        value: model?.leadPhoneNumber,
        icon: <GiSwapBag className="viewLabelIcon" size={24} />
      },
      {
        label: 'loanAmount',
        value: model?.loanAmount,
        icon: <GiSwapBag className="viewLabelIcon" size={24} />
      },
      {
        label: 'loanType',
        value: model?.loanType,
        icon: <GiSwapBag className="viewLabelIcon" size={24} />
      }
    ];
  }, [RejectedViewData]);

  const LoginProfileField = useMemo(() => {
    const model = RejectedViewData?.rejectedApplicationEntityLoginProfileResponseModel || {};

    return [
      {
        label: 'companyName',
        value: model?.companyName,
        icon: <FaRegUser className="viewLabelIcon" size={24} />
      },
      {
        label: 'currentStage',
        value: model?.currentStage,
        icon: <InterestsIcon className="viewLabelIcon" size={24} />
      },
      {
        label: 'currentStatus',
        value: model?.currentStatus,
        icon: <InterestsIcon className="viewLabelIcon" size={24} />
      },
      {
        label: 'dsaName',
        value: model?.dsaName,
        icon: <GiSwapBag className="viewLabelIcon" size={24} />
      },
      {
        label: 'lanId',
        value: model?.lanId,
        icon: <GiSwapBag className="viewLabelIcon" size={24} />
      },
      {
        label: 'loginProfileId',
        value: model?.loginProfileId,
        icon: <GiSwapBag className="viewLabelIcon" size={24} />
      },
      {
        label: 'sourceFlag',
        value: model?.sourceFlag,
        icon: <GiSwapBag className="viewLabelIcon" size={24} />
      },
      {
        label: 'sourceType',
        value: model?.sourceType,
        icon: <GiSwapBag className="viewLabelIcon" size={24} />
      }
    ];
  }, [RejectedViewData]);

  const RejectionDetails = useMemo(() => {
    const model = RejectedViewData?.rejectedApplicationEntityRejectionDetailsResponseModel || {};

    return [
      {
        label: 'reasonId',
        value: model?.reasonId,
        icon: <FaRegUser className="viewLabelIcon" size={24} />
      },
      {
        label: 'rejectedBy',
        value: model?.rejectedBy,
        icon: <InterestsIcon className="viewLabelIcon" size={24} />
      },
      {
        label: 'rejectedDate',
        value: model?.rejectedDate,
        icon: <InterestsIcon className="viewLabelIcon" size={24} />
      },
      {
        label: 'rejectionComment',
        value: model?.rejectionComment,
        icon: <GiSwapBag className="viewLabelIcon" size={24} />
      },
      {
        label: 'rejectionReason',
        value: model?.rejectionReason,
        icon: <GiSwapBag className="viewLabelIcon" size={24} />
      },
      {
        label: 'statusName',
        value: model?.statusName,
        icon: <GiSwapBag className="viewLabelIcon" size={24} />
      }
    ];
  }, [RejectedViewData]);

  const SubmissionDetails = useMemo(() => {
    const model = RejectedViewData?.rejectedApplicationEntitySubmissionDetailsResponseModel || {};

    return [
      {
        label: 'bankName',
        value: model?.bankName,
        icon: <FaRegUser className="viewLabelIcon" size={24} />
      },
      {
        label: 'comments',
        value: model?.comments,
        icon: <InterestsIcon className="viewLabelIcon" size={24} />
      },
      {
        label: 'modeOfSubmission',
        value: model?.modeOfSubmission,
        icon: <InterestsIcon className="viewLabelIcon" size={24} />
      },
      {
        label: 'personName',
        value: model?.personName,
        icon: <GiSwapBag className="viewLabelIcon" size={24} />
      },
      {
        label: 'processingCentre',
        value: model?.processingCentre,
        icon: <GiSwapBag className="viewLabelIcon" size={24} />
      },
      {
        label: 'submittedOn',
        value: model?.submittedOn,
        icon: <GiSwapBag className="viewLabelIcon" size={24} />
      }
    ];
  }, [RejectedViewData]);

  return (
    <Page title="Kpros by Kalolytic Solutions || Rejected">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="View Rejected" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>
          <Scrollbar>
            <Grid container spacing={3} mb={3}>
              {isValidValue(
                RejectedViewData?.rejectedApplicationEntityLoanRequirementResponseModel
              ) && <ViewCardComponent title="Loan Requirement" fields={loanRequirementField} />}

              {isValidValue(
                RejectedViewData?.rejectedApplicationEntityLoginProfileResponseModel
              ) && <ViewCardComponent title="Login Profile" fields={LoginProfileField} />}
              {isValidValue(
                RejectedViewData?.rejectedApplicationEntityRejectionDetailsResponseModel
              ) && <ViewCardComponent title="Rejection Details" fields={RejectionDetails} />}

              {isValidValue(
                RejectedViewData?.rejectedApplicationEntityRejectionDetailsResponseModel
              ) && <ViewCardComponent title="Submission Details" fields={SubmissionDetails} />}
            </Grid>

            {/* <Typography variant="body1" className="headingLineUp headingLineUpOut">
              Activity Log
            </Typography>
            <Box className="viewLeadCard cardTopMinusMargin">
              <Box container>
                <Box className="statusBox">
                  <Typography variant="body2">Current Status:</Typography>
                  <Typography variant="subtitle2" className="disbursedText">
                    Leads (U-Doc)
                  </Typography>
                </Box>
              </Box>
              <Box className="timelineB">
                <Box className="timelineContentB timelineContentBGreen">
                  <Typography variant="subtitle1" className="date">
                    Prospect
                  </Typography>
                  <Typography variant="body2" className="">
                    Start Date: <strong>27 April, 2022</strong>
                  </Typography>
                  <Typography variant="body2" className="" mb={1}>
                    End Date: <strong>30 April, 2022</strong>
                  </Typography>
                  <Button
                    className="mainBtnSmall"
                    onClick={(e) => {
                      setShowProspectDetail(true);
                      setShowCallCenterDetail(false);
                      setShowLeadsDetail(false);
                    }}
                  >
                    More
                  </Button>
                </Box>
                <Box className="timelineContentB timelineContentBGreen">
                  <Typography variant="subtitle1" className="date">
                    Call Center
                  </Typography>
                  <Typography variant="body2" className="">
                    Start Date: <strong>27 April, 2022</strong>
                  </Typography>
                  <Typography variant="body2" className="" mb={1}>
                    End Date: <strong>30 April, 2022</strong>
                  </Typography>
                  <Button
                    className="mainBtnSmall"
                    onClick={(e) => {
                      setShowProspectDetail(false);
                      setShowCallCenterDetail(true);
                      setShowLeadsDetail(false);
                    }}
                  >
                    More
                  </Button>
                </Box>
                <Box className="timelineContentB timelineContentBOrange">
                  <Typography variant="subtitle1" className="date">
                    Leads
                  </Typography>
                  <Typography variant="body2" className="">
                    Start Date: <strong>27 April, 2022</strong>
                  </Typography>
                  <Typography variant="body2" className="" mb={1}>
                    End Date: <strong>30 April, 2022</strong>
                  </Typography>
                  <Button
                    className="mainBtnSmall"
                    onClick={(e) => {
                      setShowProspectDetail(false);
                      setShowCallCenterDetail(false);
                      setShowLeadsDetail(true);
                    }}
                  >
                    More
                  </Button>
                </Box>
                <Box className="timelineContentB">
                  <Typography variant="subtitle1" className="date">
                    Log In
                  </Typography>
                </Box>
                <Box className="timelineContentB">
                  <Typography variant="subtitle1" className="date">
                    Revenue
                  </Typography>
                </Box>
                <Box className="timelineContentB">
                  <Typography variant="subtitle1" className="date">
                    Rejected
                  </Typography>
                </Box>
              </Box>
              {showProspectDetail ? (
                <Box className="viewLeadCard" mt={3}>
                  <Grid container spacing={3}>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Prospect ID
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Campaign Name
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Source
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Leads Assigned on
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Assigned by
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Lead Generated on
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Lead Qualified on
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Lead Qualified by
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Lead Status
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Agents Comments
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Sales Person
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              ) : null}
              {showCallCenterDetail ? (
                <Box className="viewLeadCard" mt={3}>
                  <Grid container spacing={3}>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Application ID
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Campaign Name
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Source
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Leads Assigned on
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Assigned by
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Lead Generated on
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Lead Qualified on
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Lead Qualified by
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Lead Status
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Agents Comments
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Sales Person
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              ) : null}
              {showLeadsDetail ? (
                <Box className="viewLeadCard" mt={3}>
                  <Grid container spacing={3}>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Lead ID
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Campaign Name
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Source
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Leads Assigned on
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Assigned by
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Lead Generated on
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Lead Qualified on
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Lead Qualified by
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Lead Status
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Agents Comments
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box className="">
                        <Typography variant="body2" className="labelText">
                          Sales Person
                        </Typography>
                        <Typography variant="subtitle2" className="labelValue">
                          &nbsp;
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              ) : null}
            </Box> */}
          </Scrollbar>
        </Box>
      </Container>
    </Page>
  );
}
export default ViewRejected;
